'use client';

import { c as _c } from "react/compiler-runtime";
import { DropdownMenu } from '@module/mdrt-org/shared/components/dropdown-menu/dropdown-menu';
import { Link } from '@module/mdrt-org/shared/i18n/i18n-navigation-link';
import { type LocalPaths } from '@module/mdrt-org/shared/utils/data/get-local-paths';
import { type TopicFacets } from '@module/mdrt-org/shared/utils/data/get-topic-facets';
import { type DropdownMenuProps } from '@shared/ui-components/dropdown-menu/dropdown-menu';
import { TopicTriggerIcon } from './components/topic-trigger-icon/topic-trigger-icon';
import styles from './topic-dropdown.module.scss';
const getItems = (data: TopicFacets, cmsPaths: LocalPaths): DropdownMenuProps['items'] => {
  const items = [];
  for (const item of data?.ExpandedTopics?.Name || []) {
    if (item?.name && item?.count) {
      items.push({
        children: <Link className={styles.item} href={`${cmsPaths.searchPagePath}?topic=${encodeURI(item.name)}`}>
            {item.name}&nbsp;({item.count})
          </Link>,
        id: item.name
      });
    }
  }
  return items;
};
export const TopicDropdown = t0 => {
  const $ = _c(8);
  const {
    cmsPaths,
    data,
    triggerLabel
  } = t0;
  let t1;
  if ($[0] !== cmsPaths || $[1] !== data) {
    t1 = getItems(data, cmsPaths);
    $[0] = cmsPaths;
    $[1] = data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const items = t1;
  let t2;
  if ($[3] !== triggerLabel) {
    t2 = <TopicTriggerIcon label={triggerLabel} />;
    $[3] = triggerLabel;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== items || $[6] !== t2) {
    t3 = <DropdownMenu items={items} menuClassName={styles.dropdown} shouldMenuFlip={true} TriggerIcon={t2} />;
    $[5] = items;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};